export const ITEMS_PER_PAGE:number = 12;
export const REVIEWS_PER_PAGE:number = 5;
export const DESCRIPTION_LENGTH:number = 60;